// Core
import { MdToken } from 'react-icons/md';
import { FaCrown, FaTrophy, FaMedal } from 'react-icons/fa6';

// Chakra
import {
  Box,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
} from '@chakra-ui/react';

const LeadersModal = ({
  tokens,
  allTokens,
  isOpen,
  onOpen,
  onClose,
}) => {
  // TEMP current user
  const currentUser = {
    cid: '#trh56fghj',
    score: 7010,
  };

  const leaders = [
    { cid: '#mw5hthtry', score: 12430 },
    { cid: '#w5htbhhry', score: 10890 },
    { cid: '#bhhgf5y65', score: 9870 },
    { cid: '#dsfsdggfe', score: 8530 },
    { cid: '#rth5dfgdf', score: 7990 },
    { cid: '#gfd45fgdf', score: 7420 },
    { cid: '#trh56fghj', score: 7010 },
    { cid: '#yui67ghjk', score: 6880 },
    { cid: '#ert45dfgh', score: 6450 },
    { cid: '#xcv67bnmk', score: 6210 },
    { cid: '#asd34fghj', score: 5980 },
    { cid: '#qwe45rtyu', score: 5650 },
    { cid: '#zxc56vbnm', score: 5420 },
    { cid: '#dfg67hjkl', score: 5180 },
    { cid: '#poi89lkjh', score: 4970 },
    { cid: '#mnb45vcxz', score: 4730 },
    { cid: '#lkj67hgfd', score: 4510 },
    { cid: '#rew34qasd', score: 4290 },
    { cid: '#tgb78yhnm', score: 4080 },
    { cid: '#plm56oknj', score: 3890 },
  ];

  const currentUserIndex = leaders.findIndex(
    (item) => item.cid === currentUser.cid
  );

  const currentUserPosition =
    currentUserIndex >= 0
      ? currentUserIndex + 1
      : 47; // TEMP если не в TOP 20

  const getRankStyle = (index) => {
    if (index === 0) {
      return {
        color: '#FFD84D',
        border: 'rgba(255, 216, 77, 0.55)',
        bg: 'rgba(255, 184, 0, 0.12)',
        shadow: '0 0 22px rgba(255, 184, 0, 0.18)',
      };
    }

    if (index === 1) {
      return {
        color: '#D7E4F0',
        border: 'rgba(215, 228, 240, 0.35)',
        bg: 'rgba(215, 228, 240, 0.07)',
        shadow: 'none',
      };
    }

    if (index === 2) {
      return {
        color: '#D98A55',
        border: 'rgba(217, 138, 85, 0.35)',
        bg: 'rgba(217, 138, 85, 0.07)',
        shadow: 'none',
      };
    }

    return {
      color: '#7CF7FF',
      border: 'rgba(81, 236, 255, 0.1)',
      bg: 'rgba(255,255,255,0.025)',
      shadow: 'none',
    };
  };

  const getRankIcon = (index) => {
    if (index === 0) return <FaCrown />;
    if (index === 1) return <FaTrophy />;
    if (index === 2) return <FaMedal />;

    return null;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="modal_leaders">
      <ModalOverlay />

      <ModalContent
        className="modal__simple modal__blue modal__blue_leaders"
        maxW={{ sm: '100%' }}
        mb="160px"
        maxH="calc(100vh - 100px)"
        overflow="hidden"
        position="relative"
      >
        <ModalCloseButton zIndex="10" />

        {/* Neon glow */}
        <Box
          position="absolute"
          top="-90px"
          left="-80px"
          w="220px"
          h="220px"
          bg="rgba(0, 224, 255, 0.08)"
          filter="blur(70px)"
          pointerEvents="none"
        />

        <Box
          position="absolute"
          top="-80px"
          right="-70px"
          w="200px"
          h="200px"
          bg="rgba(255, 32, 103, 0.07)"
          filter="blur(70px)"
          pointerEvents="none"
        />

        {/* Header */}
        <ModalHeader
          px="20px"
          pt="20px"
          pb="14px"
          position="relative"
          bg="rgba(0, 0, 0, 0.16)"
          borderBottom="1px solid rgba(255,255,255,0.04)"
        >
          <Flex
            align="flex-start"
            justify="space-between"
            pr="30px"
          >
            <Box>
              <Text
                fontSize="21px"
                fontWeight="900"
                letterSpacing="0.4px"
                color="rgba(255,255,255,0.82)"
              >
                Leaderboard
              </Text>

              <Flex
                align="center"
                gap="7px"
                mt="4px"
              >
                <Box
                  w="6px"
                  h="6px"
                  borderRadius="50%"
                  bg="#43F7FF"
                  opacity="0.72"
                  boxShadow="0 0 7px #43F7FF"
                />

                <Text
                  fontSize="11px"
                  color="rgba(255,255,255,0.38)"
                  fontWeight="600"
                  textTransform="uppercase"
                  letterSpacing="0.8px"
                >
                  Best score this month
                </Text>
              </Flex>
            </Box>
          </Flex>
        </ModalHeader>

        <ModalBody
          px="14px"
          pb="0"
          display="flex"
          flexDirection="column"
          overflow="hidden"
        >
          <Flex
            py="12px"
            px="8px"
            justify="space-between"
            align="center"
            flexShrink="0"
          >
            <Text
              fontSize="11px"
              color="rgba(255,255,255,0.35)"
              fontWeight="700"
              letterSpacing="0.6px"
              textTransform="uppercase"
            >
              Top 20 racers
            </Text>

            <Text
              fontSize="10px"
              color="rgba(255,255,255,0.3)"
            >
              Updated hourly
            </Text>
          </Flex>

          {/* Scroll list */}
          <Box
            flex="1"
            minH="0"
            overflowY="auto"
            pb="12px"
            pr="2px"
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'rgba(69,235,255,0.22)',
                borderRadius: '10px',
              },
            }}
          >
            <Flex
              direction="column"
              gap="7px"
            >
              {leaders.map((item, index) => {
                const style = getRankStyle(index);

                const isCurrentUser =
                  item.cid === currentUser.cid;

                return (
                  <Flex
                    key={item.cid}
                    position="relative"
                    align="center"
                    justify="space-between"
                    minH={index < 3 ? '62px' : '52px'}
                    px="12px"
                    py="8px"
                    borderRadius="15px"
                    border={
                      isCurrentUser
                        ? '1px solid rgba(67, 247, 255, 0.65)'
                        : `1px solid ${style.border}`
                    }
                    bg={
                      isCurrentUser
                        ? 'linear-gradient(90deg, rgba(0,224,255,0.14), rgba(255,32,103,0.07))'
                        : style.bg
                    }
                    boxShadow={
                      isCurrentUser
                        ? '0 0 20px rgba(67,247,255,0.12)'
                        : style.shadow
                    }
                    overflow="hidden"
                    transition="0.18s ease"
                    _hover={{
                      transform: 'translateX(2px)',
                    }}
                  >
                    {index === 0 && !isCurrentUser && (
                      <Box
                        position="absolute"
                        inset="0"
                        bg="linear-gradient(90deg, rgba(255,198,0,0.08), transparent 55%)"
                        pointerEvents="none"
                      />
                    )}

                    {isCurrentUser && (
                      <Box
                        position="absolute"
                        top="5px"
                        right="7px"
                        px="6px"
                        py="2px"
                        borderRadius="6px"
                        bg="rgba(67,247,255,0.12)"
                        border="1px solid rgba(67,247,255,0.18)"
                      >
                        <Text
                          fontSize="8px"
                          lineHeight="1"
                          fontWeight="900"
                          color="#74F8FF"
                          letterSpacing="0.7px"
                        >
                          YOU
                        </Text>
                      </Box>
                    )}

                    <Flex
                      align="center"
                      gap="11px"
                      minW="0"
                      zIndex="1"
                    >
                      <Flex
                        align="center"
                        justify="center"
                        flexShrink="0"
                        w={index < 3 ? '36px' : '30px'}
                        h={index < 3 ? '36px' : '30px'}
                        borderRadius="11px"
                        bg={
                          index < 3
                            ? 'rgba(255,255,255,0.06)'
                            : 'rgba(65,238,255,0.05)'
                        }
                        color={
                          isCurrentUser
                            ? '#43F7FF'
                            : style.color
                        }
                        fontSize={
                          index < 3 ? '15px' : '12px'
                        }
                        fontWeight="900"
                        border="1px solid rgba(255,255,255,0.06)"
                      >
                        {getRankIcon(index) || index + 1}
                      </Flex>

                      <Box minW="0">
                        <Text
                          fontSize={
                            index < 3 ? '14px' : '13px'
                          }
                          fontWeight={
                            isCurrentUser
                              ? '900'
                              : index < 3
                                ? '800'
                                : '700'
                          }
                          whiteSpace="nowrap"
                          overflow="hidden"
                          textOverflow="ellipsis"
                          color={
                            isCurrentUser
                              ? '#B9FBFF'
                              : index === 0
                                ? '#FFF4B3'
                                : '#F4F7FB'
                          }
                        >
                          {item.cid}
                        </Text>

                        {index < 3 && (
                          <Text
                            mt="1px"
                            fontSize="9px"
                            textTransform="uppercase"
                            letterSpacing="0.8px"
                            color="rgba(255,255,255,0.32)"
                          >
                            {index === 0
                              ? 'Street King'
                              : index === 1
                                ? 'Night Runner'
                                : 'Road Hunter'}
                          </Text>
                        )}
                      </Box>
                    </Flex>

                    <Flex
                      align="center"
                      gap="6px"
                      pl="8px"
                      pr={isCurrentUser ? '34px' : '0'}
                      zIndex="1"
                    >
                      <MdToken
                        size={index < 3 ? 19 : 16}
                        color={
                          isCurrentUser
                            ? '#43F7FF'
                            : style.color
                        }
                        style={{
                          filter:
                            index === 0
                              ? 'drop-shadow(0 0 6px rgba(255,200,0,0.65))'
                              : isCurrentUser
                                ? 'drop-shadow(0 0 5px rgba(67,247,255,0.5))'
                                : 'none',
                        }}
                      />

                      <Text
                        fontSize={
                          index < 3 ? '15px' : '13px'
                        }
                        fontWeight="900"
                        fontVariantNumeric="tabular-nums"
                        color={
                          isCurrentUser
                            ? '#43F7FF'
                            : style.color
                        }
                      >
                        {item.score.toLocaleString()}
                      </Text>
                    </Flex>
                  </Flex>
                );
              })}
            </Flex>
          </Box>

          {/* Current user fixed card */}
          <Box
            flexShrink="0"
            px="14px"
            position="fixed"
            w="100%"
            left="0"
            bottom="10px"
            pt="10px"
            pb="16px"
            bg="linear-gradient(180deg, rgba(7,11,22,0.82) 0%, rgba(5,8,18,0.98) 35%)"
            borderTop="1px solid rgba(67,247,255,0.13)"
            boxShadow="0 -12px 30px rgba(0,0,0,0.35)"
          >
            <Flex
              position="relative"
              align="center"
              justify="space-between"
              px="12px"
              py="11px"
              borderRadius="15px"
              bg="linear-gradient(90deg, rgba(0,224,255,0.12), rgba(255,32,103,0.06))"
              border="1px solid rgba(67,247,255,0.38)"
              boxShadow="
                inset 0 0 18px rgba(67,247,255,0.04),
                0 0 18px rgba(67,247,255,0.08)
              "
            >
              <Flex
                align="center"
                gap="11px"
                minW="0"
              >
                <Flex
                  align="center"
                  justify="center"
                  w="34px"
                  h="34px"
                  flexShrink="0"
                  borderRadius="11px"
                  bg="rgba(67,247,255,0.08)"
                  border="1px solid rgba(67,247,255,0.16)"
                  color="#43F7FF"
                  fontSize="12px"
                  fontWeight="900"
                >
                  {currentUserPosition}
                </Flex>

                <Box minW="0">
                  <Flex
                    align="center"
                    gap="7px"
                  >
                    <Text
                      fontSize="13px"
                      fontWeight="900"
                      color="#D7FDFF"
                      whiteSpace="nowrap"
                      overflow="hidden"
                      textOverflow="ellipsis"
                    >
                      {currentUser.cid}
                    </Text>

                    <Box
                      px="5px"
                      py="2px"
                      borderRadius="5px"
                      bg="rgba(67,247,255,0.11)"
                    >
                      <Text
                        fontSize="8px"
                        lineHeight="1"
                        fontWeight="900"
                        color="#43F7FF"
                        letterSpacing="0.6px"
                      >
                        YOU
                      </Text>
                    </Box>
                  </Flex>

                  <Text
                    mt="2px"
                    fontSize="9px"
                    color="rgba(255,255,255,0.35)"
                    textTransform="uppercase"
                    letterSpacing="0.7px"
                  >
                    Your monthly best
                  </Text>
                </Box>
              </Flex>

              <Flex
                align="center"
                gap="6px"
                pl="8px"
              >
                <MdToken
                  size={18}
                  color="#43F7FF"
                  style={{
                    filter:
                      'drop-shadow(0 0 5px rgba(67,247,255,0.55))',
                  }}
                />

                <Text
                  fontSize="15px"
                  fontWeight="900"
                  color="#43F7FF"
                  fontVariantNumeric="tabular-nums"
                >
                  {currentUser.score.toLocaleString()}
                </Text>
              </Flex>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LeadersModal;